import ITask from '../../../Utility/Task/ITask';
import WorldSystem from '../WorldSystem';
import { PlayerTask } from '../../../State/Player/PlayerTasks';
import RewardAnimationHelper from './RewardAnimationHelper';
import { PlayerActions } from '../../../State/Player/PlayerActions';

export default class RewardSyncTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<number> {
        const target = system.getCurrentLevelNode();
        const tasksToClear = [];
        for (const taskData of system.store.getState().playerState.tasks) {
            let clearTask: boolean = true;
            switch (taskData.task) {
                case PlayerTask.COIN:
                    RewardAnimationHelper.coins(system, taskData);
                    break;
                case PlayerTask.TNT:
                    RewardAnimationHelper.boosterTNT(system, taskData, target);
                    break;
                case PlayerTask.BULLS_EYE:
                    RewardAnimationHelper.boosterBullsEye(system, taskData, target);
                    break;
                case PlayerTask.SHUFFLE:
                    RewardAnimationHelper.boosterShuffle(system, taskData, target);
                    break;
                case PlayerTask.JOKER:
                    RewardAnimationHelper.jokers(system, taskData, target);
                    break;
                case PlayerTask.EXTRA_CARDS:
                    RewardAnimationHelper.extraCards(system, taskData, target);
                    break;
                case PlayerTask.UNDO:
                    RewardAnimationHelper.boosterUndo(system, taskData, target);
                    break;
                case PlayerTask.FREE_PLAY_REWARD:
                    RewardAnimationHelper.freePlay(system, taskData, target);
                    break;
                case PlayerTask.STAR_CHEST_STAR_REWARD:
                    RewardAnimationHelper.starChestStars(system, taskData, target);
                    break;
                case PlayerTask.REWARD_BOOSTER:
                    RewardAnimationHelper.rewardAnyBooster(system, taskData, target);
                    break;
                default:
                    clearTask = false;
                    break;
            }

            if (clearTask) {
                tasksToClear.push(taskData);
            }
        }

        if (tasksToClear.length > 0) {
            PlayerActions.clearTasks(tasksToClear);
        }
    }
}
